import { render, staticRenderFns } from "./FormRL06.vue?vue&type=template&id=392782c0"
import script from "./FormRL06.vue?vue&type=script&lang=js"
export * from "./FormRL06.vue?vue&type=script&lang=js"
import style0 from "./FormRL06.vue?vue&type=style&index=0&id=392782c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports